import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { Customer } from '@usf/customer-types';
import { OrderHeader, OrderItem } from '@usf/ngrx-order';
import { BehaviorSubject, Observable } from 'rxjs';
import { SubmittedOrderViewModel } from 'src/app/order/models/submitted-order-view-model';
import { Product } from '../../models/product.model';
import { FEATURES } from '@shared/constants/splitio-features';
import { WillCallEvent } from '../../../order/models/will-call-event';

@Component({
  selector: 'app-will-call-modal',
  templateUrl: './will-call-modal.component.html',
  styleUrls: ['./will-call-modal.component.scss'],
  providers: [DatePipe],
})
export class WillCallModalComponent implements OnInit {
  @Input() orderHeader: OrderHeader;
  @Input() orderItems: OrderItem[];
  @Input() products: Map<number, Product>;
  @Input() customer: Customer;
  @Input() isOnline$: Observable<boolean>;

  @Output() submitEvent = new EventEmitter<WillCallEvent>();
  @Output() cancelEvent = new EventEmitter<WillCallEvent>();
  willCallForm: FormGroup;
  vm: SubmittedOrderViewModel;
  dateTime$: BehaviorSubject<Date>;
  editMode = false;
  minPickupDate: Date | string;
  maxPickupDate: Date | string;
  currentPickupDate: Date | String;
  isCalendarChanged = false;

  constructor(
    readonly platformService: PlatformService,
    public popoverController: PopoverController,
    private fb: FormBuilder,
    private datePipe: DatePipe,
  ) {}

  ngOnInit() {
    let formatMinDate = new Date();
    console.log('calendar formatMinDate: ', formatMinDate.toISOString());
    let offset = formatMinDate.getTimezoneOffset();
    formatMinDate.setHours(formatMinDate.getHours() - (offset / 60 - 1)); //-1 for daylight savings in winter
    this.minPickupDate = formatMinDate.toISOString();
    this.currentPickupDate = formatMinDate.toISOString();

    if (!!this.orderHeader?.willCallDateTime) {
      if (typeof this.orderHeader?.willCallDateTime === 'string') {
        this.currentPickupDate = this.orderHeader?.willCallDateTime;
      } else {
        this.currentPickupDate =
          this.orderHeader?.willCallDateTime.toISOString();
      }
    }

    let formatMaxDate = new Date(this.minPickupDate);
    formatMaxDate.setDate(formatMaxDate.getDate() + 30);
    this.maxPickupDate = formatMaxDate.toISOString();

    if (this.orderHeader?.orderType === 'WC') {
      this.editMode = true;
    }

    // Default to "customer" when field is uneditable
    const willCallType = this.orderHeader?.willCallType ?? '';

    this.willCallForm = this.fb.group({
      originalDeliveryDate: new FormControl(
        this.datePipe.transform(
          this.orderHeader?.confirmedDeliveryDate,
          'M/d/yyyy',
          'GMT',
        ),
      ),
      pickupDateTime: new FormControl(this.currentPickupDate),
      customerName: new FormControl('', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(25),
      ]),
      customerPo: new FormControl(
        this.orderHeader?.purchaseOrderNumber
          ? this.orderHeader?.purchaseOrderNumber
          : 'N/A',
      ),
      willCallType: new FormControl(willCallType, [Validators.required]),
      specialInstructions: new FormControl(
        !!this.orderHeader?.willCallSpecialInstructions
          ? this.orderHeader?.willCallSpecialInstructions
          : '',
        [Validators.maxLength(100)],
      ),
    });
  }
  //Temporary fix for ionic time zone issue
  ionChange(changed: boolean) {
    this.isCalendarChanged = changed;
    console.log('calendar changed: ', this.isCalendarChanged);
    console.log(
      'selected calendar date: ',
      this.willCallForm.controls.pickupDateTime.value,
    );
  }

  async submit() {
    const willCallDateTime =
      this.willCallForm.get('pickupDateTime')?.value.endsWith('Z') ||
      !this.isCalendarChanged
        ? this.willCallForm.get('pickupDateTime')?.value
        : this.willCallForm.get('pickupDateTime')?.value + 'Z';

    const willCallEvent: WillCallEvent = {
      willCallPersonName: this.willCallForm.get('customerName')?.value,
      willCallSpecialInstructions: this.willCallForm.get('specialInstructions')
        ?.value,
      willCallDateTime,
      willCallType: this.willCallForm.get('willCallType')?.value,
    };
    this.submitEvent.emit(willCallEvent);
  }

  async cancel() {
    const willCallDateTime =
      this.willCallForm.get('pickupDateTime')?.value.endsWith('Z') ||
      !this.isCalendarChanged
        ? this.willCallForm.get('pickupDateTime')?.value
        : this.willCallForm.get('pickupDateTime')?.value + 'Z';
    const willCallEvent: WillCallEvent = {
      willCallPersonName: this.willCallForm.get('customerName')?.value,
      willCallSpecialInstructions: this.willCallForm.get('specialInstructions')
        ?.value,
      willCallDateTime,
      willCallType: this.willCallForm.get('willCallType')?.value,
    };
    this.cancelEvent.emit(willCallEvent);
  }
}
